module.exports = __webpack_public_path__ + "img/EyeIcon.455668b4.svg";